import UserAvatar from "../generic/UserAvatar";
import { useAuth } from "../../contexts/auth.context";
import { User, newUser } from "../../types/User";
import { signoutUser } from "../../../features/api/userSlice";

import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

// button style signin/signout/signup
const BootstrapButton = styled(Button)({
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    borderColor: "#FFFFFF",
    color: "#FFFFFF",

    "&:hover": {
        color: "#FFFFFF",
        borderColor: "#FFFFFF",
        boxShadow: "none",
    },
    "&:active": {
        color: "#FFFFFF",
        boxShadow: "none",
        borderColor: "#FFFFFF",
    },
});

const SigninButton: React.FC = () => {
    const navigate = useNavigate();
    return (
        <BootstrapButton variant="outlined" onClick={() => navigate("/signin")}>
            Sign in
        </BootstrapButton>
    );
};

// props for sign out button
export type SignoutButtonProps = {
    user: User;
    setUser: React.Dispatch<React.SetStateAction<User>>;
};

export const SignoutButton: React.FC<SignoutButtonProps> = ({ user, setUser }) => {
    const navigate = useNavigate();

    function handleButton() {
        // sign out
        try {
            signoutUser();
            setUser(newUser());
            console.log(user.id + " signed out");
            navigate("/");
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <BootstrapButton variant="outlined" onClick={handleButton}>
            Sign out
        </BootstrapButton>
    );
};

const SignupButton: React.FC = () => {
    const navigate = useNavigate();

    return (
        <BootstrapButton
            variant="outlined"
            onClick={() => navigate("/signup")}
            sx={{ backgroundColor: "white", color: "#2196f3" }}
        >
            Sign up
        </BootstrapButton>
    );
};

const TopBarOptions: React.FC = () => {
    const { user, setUser } = useAuth();

    if (user.id === -1) {
        // display signin and signup if not signed in
        return (
            <Stack direction={"row"} spacing={1}>
                <SigninButton />
                <SignupButton />
            </Stack>
        );
    } else {
        // display avatar and sign out if signed in
        return (
            <Stack direction={"row"} spacing={5}>
                <SignoutButton user={user} setUser={setUser} />
                <UserAvatar user={user} size={20} />
            </Stack>
        );
    }
};

export default TopBarOptions;
